import { path } from 'ramda';
import { IPhotoSchema } from 'shared/types/carousel';

import { IState } from '../../store';
import { IFloorPlan } from '../../types/floorPlan';

export const getFloorPlan = (state: IState): IPhotoSchema | null => {
  const floorPlan = path<IFloorPlan>(['offerData', 'floorPlan'], state);

  if (!floorPlan) {
    return null;
  }

  return {
    fullUrl: floorPlan.imageUrl,
    thumbnailUrl: floorPlan.imageUrl,
    polygonPath: floorPlan.polygonPath,
    isLayout: false,
    isFloorPlan: true,
  };
};
